import * as gfunctions from '../../../js/generalFunctions';

CCL.checkoutODG = {
  autoload: [
    ['editDelivery', $('.delivery-details').length > 0],
    ['accordionSelect', $('.delivery-details-container').length > 0],
    ['toggleAccordion', $('.delivery-details-container').length > 0],
    ['editRecipient', $('.recipient-details').length > 0],
    ['editGiftMessage', $('.gift-options').length > 0],
    ['cancelEditDelivery', $('.delivery-details-container').length > 0],
    ['cancelEditRecipient', $('.delivery-details-container').length > 0],
    ['cancelEditGiftOptions', $('.delivery-details-container').length > 0],
    ['saveDeliverySection', $('.delivery-details-container').length > 0],
    ['saveRecipientSection', $('.delivery-details-container').length > 0],
    ['saveGiftOptionsSection', $('.delivery-details-container').length > 0],
    ['loadItemsToBeDeliveredOnCheck', $('.custom-control-input.delivery-option-checkbox').length > 0],
    ['surpriseCheckboxCall', $('.custom-checkbox .custom-control-input.surprise').length > 0],
    ['giftMsgCheckbox', $('.gift-options .addMessageGift').length > 0],
    ['getSelectedRecipientGuest', $('.delivery-details-container').length > 0],
    ['textAreaCharacters', $('.delivery-details-container').length > 0],
    ['shiftingPromoWaterMark', $('.c-checkout-onboard-delivery-card').length > 0],
    ['shiftingPromoWaterMark', $('.c-cart').length > 0]
  ],

  timer: null,

  /* Suprise checkbox call */
  surpriseCheckboxCall() {
    $('.c-checkout-odg-sailing-nonsailing').on('click', '.custom-checkbox .custom-control-input.surprise', ((event) => {
      const deliveryType = $(event.currentTarget.closest('.delivery-details-container')).data('deliverytype');
      const method = 'POST';
      const ajaxUrl = `/shop/checkout/saveGiftAndSurprise/${deliveryType}`;
      const dataObj = {
        surprise: $(event.currentTarget).prop('checked'),
        surpriseCall: true,
        entryNumber: $(event.currentTarget.parentElement.parentElement.closest('.delivery-details-container')).find('.product').data('entrynumber'),
        sequenceNumber: $(event.currentTarget.parentElement.parentElement.closest('.delivery-details-container')).find('.product').data('sequencenumber'),
        productId: $(event.currentTarget.parentElement.parentElement.closest('.delivery-details-container')).find('.product').data('productid'),
        selectedStateroom: $(event.currentTarget.parentElement.parentElement.closest('.delivery-details-container')).find('.product').data('bookingid')
      };
      this.surpriseCheckboxAjaxCall(dataObj, event, ajaxUrl, method);
    }));
  },
  async surpriseCheckboxAjaxCall(dataObj, event, ajaxUrl, methodAjax) {
    const token = $('#csrfSessionToken').data('csrf');
    const ajaxObj = {
      type: methodAjax,
      url: ajaxUrl,
      contentType: 'application/json',
      data: JSON.stringify(dataObj),
      headers: {
        CSRFToken: token
      }
    };
    try {
      const res = await gfunctions.doAjax(ajaxObj);
      this.loadCheckboxDataHBS(res, event);
      gfunctions.hideLoader();
    } catch (err) {
      const cartAPIError = { customError: err };
      gfunctions.hideLoader();
      console.log(cartAPIError);
    }
  },
  /* Checkbox check functionality for Items to be delivered */
  loadItemsToBeDeliveredOnCheck() {
    $('.c-checkout-odg-sailing-nonsailing').on('click', '.custom-control-input.delivery-option-checkbox', ((event) => {
      const deliveryType = $(event.currentTarget.parentElement.parentElement.nextElementSibling).find('.delivery-details-container').data('deliverytype');
      let ajaxUrl = '';
      const method = 'GET';
      if (window.location.hostname === 'localhost' && window.location.port === '6565') {
        ajaxUrl = '/_ui/responsive/ccl/assets/templates/checkout-onboard-delivery/checkout-delivery-checkbox.json';
      } else {
        ajaxUrl = `/shop/checkout/toogle?deliveryType=${deliveryType}`;
      }
      this.getItemsDelivereddData(event, ajaxUrl, method);
    }));
  },
  async getItemsDelivereddData(event, ajaxUrl, methodAjax) {
    gfunctions.showLoader();
    const token = $('#csrfSessionToken').data('csrf');
    const ajaxObj = {
      type: methodAjax,
      url: ajaxUrl,
      contentType: 'application/json',
      headers: {
        CSRFToken: token
      }
    };
    try {
      const res = await gfunctions.doAjax(ajaxObj);
      this.loadCheckboxDataHBS(res, event);
      gfunctions.hideLoader();
    } catch (err) {
      const cartAPIError = { customError: err };
      gfunctions.hideLoader();
      console.log(cartAPIError);
    }
  },

  async loadCheckboxDataHBS(editDataObj, event) {
    gfunctions.showLoader();
    const ajaxUrl = '/_ui/responsive/ccl/assets/templates/checkout-onboard-delivery/checkout-delivery-checkbox-response.html';
    const methodAjax = 'GET';
    const token = $('#csrfSessionToken').data('csrf');
    const ajaxObj = {
      type: methodAjax,
      url: ajaxUrl,
      headers: {
        CSRFToken: token
      }
    };
    try {
      const res = await gfunctions.doAjax(ajaxObj);
      const html = gfunctions.createDynamicHTML(res, editDataObj);
      $(event.target.parentNode.parentElement.nextElementSibling.closest('.delivery-details-wrapper')).empty().append(html);
      gfunctions.hideLoader();
    } catch (err) {
      const cartAPIError = { customError: err };
      gfunctions.hideLoader();
      console.log(cartAPIError);
    }
  },

  /* Edit Sections */
  editDelivery() {
    $('.c-checkout-odg-sailing-nonsailing').on('click keypress', '.delivery .edit-wrap', ((event) => {
      if (event.type === 'click' || event.keyCode === 13) {
        event.preventDefault();
        const dataObj = {
          entryNumber: $(event.target.closest('.delivery-details').previousElementSibling).find('.product').attr('data-entrynumber'),
          sequenceNumber: $(event.target.closest('.delivery-details').previousElementSibling).find('.product').attr('data-sequencenumber'),
          selectedStateroom: $(event.target.closest('.delivery-details').previousElementSibling).find('.product').attr('data-bookingid')
        };
        let ajaxUrl = '';
        let method = 'POST';
        if (window.location.hostname === 'localhost' && window.location.port === '6565') {
          ajaxUrl = '/_ui/responsive/ccl/assets/templates/checkout-onboard-delivery/checkout-onboard-delivery.json';
          method = 'GET';
        } else {
          ajaxUrl = '/shop/checkout/getStateroomAndDays';
        }
        // AJAX call
        this.loadEditData(dataObj, event, ajaxUrl, method, $(event.currentTarget).data('editsection'), null, null);
      }
    }));
  },
  editRecipient() {
    $('.c-checkout-odg-sailing-nonsailing').on('click keypress', '.recipient .edit-wrap', ((event) => {
      if (event.type === 'click' || event.keyCode === 13) {
        event.preventDefault();
        const dataObj = {
          entryNumber: $(event.currentTarget.closest('.recipient-details').parentElement).find('.product-wrap .product').data('entrynumber'),
          sequenceNumber: $(event.currentTarget.closest('.recipient-details').parentElement).find('.product-wrap .product').data('sequencenumber')
        };
        let ajaxUrl = '';
        let method = 'POST';
        if (window.location.hostname === 'localhost' && window.location.port === '6565') {
          ajaxUrl = '/_ui/responsive/ccl/assets/templates/checkout-onboard-delivery/checkout-onboard-delivery.json';
          method = 'GET';
        } else {
          ajaxUrl = '/shop/checkout/getRecipientGuest';
        }
        // AJAX call
        this.loadEditData(dataObj, event, ajaxUrl, method, null, $(event.currentTarget).data('editsection'), null);
      }
    }));
  },

  giftMsgCheckbox() {
    $('.c-checkout-odg-sailing-nonsailing').on('click', '.gift-options .addMessageGift', ((event) => {
      const giftMsg = $(event.currentTarget.parentElement.nextElementSibling).find('.saved-text').text();
      const checkboxElem = $(event.currentTarget).hasClass('addMessageGift');
      $(event.currentTarget.parentElement.nextElementSibling).find('.saved-text').attr('role', 'alert');
      $(event.currentTarget.parentElement.nextElementSibling).find('.saved-text').attr('aria-live', 'assertive');
      if ($(event.currentTarget).prop('checked')) {
        const result = {
          giftOptionMsg: $(event.currentTarget.parentNode.parentElement).find('.saved-text').text()
        };
        this.repaintSectionOnEdit(event, result, null, null, $(event.currentTarget).data('editsection'));
      } else {
        const deliverytype = $(event.currentTarget.closest('.delivery-details-container')).data('deliverytype');
        const dataObj = {
          giftMessage: '',
          deliveryType: deliverytype, // from the data attribute of checkbox
          entryNumber: $(event.currentTarget.closest('.gift-options').parentElement).find('.product-wrap .product').data('entrynumber'),
          sequenceNumber: $(event.currentTarget.closest('.gift-options').parentElement).find('.product-wrap .product').data('sequencenumber'),
          productId: $(event.currentTarget.closest('.gift-options').parentElement).find('.product-wrap .product').data('productid'),
          selectedStateroom: $(event.currentTarget.closest('.gift-options').parentElement).find('.product-wrap .product').data('bookingid')
        };
        let ajaxUrl = '';
        let method = 'POST';
        if (window.location.hostname === 'localhost' && window.location.port === '6565') {
          ajaxUrl = '/_ui/responsive/ccl/assets/templates/checkout-onboard-delivery/checkout-onboard-delivery.json';
          method = 'GET';
        } else {
          ajaxUrl = `/shop/checkout/saveGiftAndSurprise/${deliverytype}`;
        }
        this.loadSaveData(dataObj, $(event.currentTarget.parentElement.closest('.message-wrap')), ajaxUrl, method, $(event.currentTarget).data('editsection'), checkboxElem);
      }
    }));
  },
  editGiftMessage() {
    $('.c-checkout-odg-sailing-nonsailing').on('click keypress', '.gift-options .edit-wrap', ((event) => {
      if (event.type === 'click' || event.keyCode === 13) {
        event.preventDefault();
        const result = {
          giftOptionMsg: $(event.currentTarget.parentNode.parentElement).find('.saved-text').text()
        };
        $(event.currentTarget.parentNode.parentElement).find('.saved-text').hide();
        this.repaintSectionOnEdit(event, result, null, null, $(event.currentTarget).data('editsection'));
      }
    }));
  },
  getSelectedRecipientGuest() {
    $('.c-checkout-odg-sailing-nonsailing').on('click', '.custom-checkbox .recipient-guest', ((event) => {
      const selectedGuestList = $('.custom-checkbox .recipient-guest:checked');
      if (!selectedGuestList.length) {
        $('.btn-save-recipient').attr('disabled', 'disabled');
      } else {
        $('.btn-save-recipient').removeAttr('disabled');
      }
    }));
  },
  repaintSectionOnEdit(event, result, sTypeD, sTypeR, sTypeG) {
    console.log('repaintSectionOnEdit event: ', event);
    result.sectionTypeD = sTypeD;
    result.sectionTypeR = sTypeR;
    result.sectionTypeG = sTypeG;
    const selectedGuestList = $('.custom-checkbox .recipient-guest:checked');
    result.isGuestChecked = !selectedGuestList.length;
    if (sTypeD) {
      result.productId = $(event.target.closest('.delivery-details').previousElementSibling).find('.product').data('productid');
    }
    // AJAX call for repainting edit html
    this.loadEditDataHBS(result, event);
  },
  async loadEditDataHBS(editDataObj, event) {
    gfunctions.showLoader();
    const ajaxUrl = '/_ui/responsive/ccl/assets/templates/checkout-onboard-delivery/checkout-onboar-delivery-edit.html';
    const methodAjax = 'GET';
    const token = $('#csrfSessionToken').data('csrf');
    const bodyBorder = $(event.target).closest('.body-border');
    const ajaxObj = {
      type: methodAjax,
      url: ajaxUrl,
      headers: {
        CSRFToken: token
      }
    };
    try {
      const res = await gfunctions.doAjax(ajaxObj);
      const html = gfunctions.createDynamicHTML(res, editDataObj);
      if (editDataObj.sectionTypeG) {
        if (event.target.parentNode.closest('.message-wrap')) {
          $(event.target.parentNode.closest('.message-wrap').nextElementSibling).empty().append(html);
          $(event.target.parentNode.closest('.message-wrap').nextElementSibling).show();
          $(event.target.closest('.edit-wrap')).addClass('hide');
          this.calculateTextAreaCharacter($(event.currentTarget.parentNode.closest('.message-wrap').nextElementSibling).find('.gift-msg-text'));
        } else {
          $(event.target.parentNode.closest('.message-wrap').nextElementSibling).empty().append(html);
          $(event.target.parentNode.closest('.message-wrap').nextElementSibling).show();
          $(event.target.closest('.edit-wrap')).addClass('hide');
          this.calculateTextAreaCharacter($(event.target.parentNode.closest('.message-wrap').nextElementSibling).find('.gift-msg-text'));
        }
      } else {
        bodyBorder.next().empty().append(html);
        bodyBorder.hide();
        bodyBorder.next().show();
      }
      gfunctions.hideLoader();
    } catch (err) {
      const cartAPIError = { customError: err };
      gfunctions.hideLoader();
      console.log(cartAPIError);
    }
  },
  async loadEditData(dataObj, editElement, ajaxUrl, methodAjax, sTypeD, sTypeR, sTypeG) {
    const token = $('#csrfSessionToken').data('csrf');
    const ajaxObj = {
      type: methodAjax,
      url: ajaxUrl,
      contentType: 'application/json',
      data: JSON.stringify(dataObj),
      headers: {
        CSRFToken: token
      }
    };
    gfunctions.showLoader();
    try {
      const res = await gfunctions.doAjax(ajaxObj);
      this.repaintSectionOnEdit(editElement, res.onBoardData, sTypeD, sTypeR, sTypeG);
      gfunctions.hideLoader();
    } catch (err) {
      const cartAPIError = { customError: err };
      gfunctions.hideLoader();
      console.log(cartAPIError);
    }
  },
  /* Cancel Funtionalities */
  cancelEditDelivery() {
    $('.c-checkout-odg-sailing-nonsailing').on('click', '.btn-cancel-delivery', ((event) => {
      event.preventDefault();
      let ajaxUrl = '';
      let method = 'POST';
      if (window.location.hostname === 'localhost' && window.location.port === '6565') {
        ajaxUrl = '/_ui/responsive/ccl/assets/templates/checkout-onboard-delivery/checkout-onboard-delivery.json';
        method = 'GET';
      } else {
        ajaxUrl = '/shop/checkout/getStateroomAndDays';
      }
      const dataObj = {
        entryNumber: $(event.currentTarget.closest('.delivery-details').parentElement).find('.product-wrap .product').data('entrynumber'),
        sequenceNumber: $(event.currentTarget.closest('.delivery-details').parentElement).find('.product-wrap .product').data('sequencenumber'),
        selectedStateroom: $(event.currentTarget.closest('.delivery-details').parentElement).find('.product-wrap .product').data('bookingid')
      };
      // AJAX call
      this.loadCancelData(dataObj, ajaxUrl, method, event.target, 'delivery');
    }));
  },
  cancelEditRecipient() {
    $('.c-checkout-odg-sailing-nonsailing').on('click', '.btn-cancel-recipient', ((event) => {
      event.preventDefault();
      const dataObj = {
        entryNumber: $(event.currentTarget.closest('.recipient-details').parentElement).find('.product-wrap .product').data('entrynumber'),
        sequenceNumber: $(event.currentTarget.closest('.recipient-details').parentElement).find('.product-wrap .product').data('sequencenumber')
      };
      let ajaxUrl = '';
      let method = 'POST';
      if (window.location.hostname === 'localhost' && window.location.port === '6565') {
        ajaxUrl = '/_ui/responsive/ccl/assets/templates/checkout-onboard-delivery/checkout-onboard-delivery.json';
        method = 'GET';
      } else {
        ajaxUrl = '/shop/checkout/getRecipientGuest';
      }
      // AJAX call
      this.loadCancelData(dataObj, ajaxUrl, method, event.target, 'recipient');
    }));
  },
  cancelEditGiftOptions() {
    $('.c-checkout-odg-sailing-nonsailing').on('click', '.btn-cancel-gift', ((event) => {
      event.preventDefault();
      const giftMsg = $(event.currentTarget.parentNode.parentElement.parentElement.previousElementSibling).find('.saved-text').text();
      $(event.currentTarget).closest('.gift-edit-wrap').hide();
      if (giftMsg) {
        $(event.currentTarget.parentNode.parentElement.parentElement.previousElementSibling).find('.edit-wrap').removeClass('hide');
      } else {
        $(event.currentTarget.parentNode.parentElement.parentElement.previousElementSibling).find('.edit-wrap').addClass('hide');
        $(event.currentTarget.parentNode.parentElement.parentElement.previousElementSibling).find('.addMessageGift').prop('checked', false);
      }
    }));
  },
  repaintDelivery(res, target) {
    let stateroomNo;
    let mkup2;
    const { selectedStateroom } = res.onBoardData;
    $.each(res.onBoardData.bookingInformation, (i, elem) => {
      if (elem.bookingId === selectedStateroom) {
        stateroomNo = elem.stateroomNumber;
        return false;
      }
      return stateroomNo;
    });
    if (selectedStateroom === 'DININGROOM') {
      mkup2 = '<div> Dining Room </div>';
    } else {
      mkup2 = `<div>Stateroom ${stateroomNo}: ${res.onBoardData.selectedStateroomName}'s Room</div>`;
    }
    const mkup1 = '<div class="flex-container">';
    const mkup3 = `<div class="edit-wrap" tabindex="0" role="button" aria-label="edit delivery details" data-editsection="delivery"><img class="edit-img" src="/_ui/responsive/ccl/assets/icons/edit.svg" alt="edit icon" role="textbox">Edit</div> </div><div>${res.onBoardData.dayDetails}<div>`;
    $(target.parentNode.parentElement.parentElement.previousElementSibling).show();
    $(target.parentNode.parentElement.parentElement.previousElementSibling).empty().append(mkup1 + mkup2 + mkup3);
    $(target.parentNode.parentElement.parentElement.previousElementSibling).find('.edit-wrap').addClass('ada-highlighted');
    $(target.parentNode.parentElement.parentElement.previousElementSibling).find('.edit-wrap').focus();
    $(target.parentNode.parentElement.parentElement).hide();
    if (res.onBoardData.deliveryType === 'SPECIAL_TYPE_DELIVERABLE') {
      $(target.parentNode.parentElement.parentElement.previousElementSibling.closest('.delivery-details').previousElementSibling).find('.product').attr('data-bookingid', selectedStateroom);
    }
  },
  repaintRecipient(res, target) {
    const mkup1 = '<div class="flex-container">';
    const mkup2 = `<div>${res.onBoardData.selectedRecipientsName}</div>`;
    const mkup3 = '<div class="edit-wrap" tabindex="0" role="button" aria-label="edit recipient details" data-editsection="recipient"><img class="edit-img" src="/_ui/responsive/ccl/assets/icons/edit.svg" alt="edit icon">Edit</div> </div>';
    $(target.parentNode.parentElement.parentElement.previousElementSibling).show();
    $(target.parentNode.parentElement.parentElement.previousElementSibling).empty().append(mkup1 + mkup2 + mkup3);
    $(target.parentNode.parentElement.parentElement.previousElementSibling).find('.edit-wrap').addClass('ada-highlighted');
    $(target.parentNode.parentElement.parentElement.previousElementSibling).find('.edit-wrap').focus();
    $(target.parentNode.parentElement.parentElement).hide();
  },
  repaintGiftOptions: function repaintGiftOptions(res, target, ischeckboxElem) {
    console.log('res:', res);
    $(target.nextElementSibling).hide();
    $(target).find('.saved-text').text(res.onBoardData.giftMessage);
    $(target).find('.saved-text').attr('aria-label', `added gift message ${res.onBoardData.giftMessage}`);
    $(target).find('.saved-text').show();
    if (!res.onBoardData.giftMessage || !$(target).find('.saved-text').text()) {
      $(target).find('.edit-wrap').addClass('hide');
      $(target).find('.addMessageGift').prop('checked', false);
    } else {
      $(target).find('.edit-wrap').removeClass('hide');
      $(target).find('.edit-wrap').addClass('ada-highlighted');
      $(target).find('.edit-wrap').focus();
      if (!ischeckboxElem) {
        $(target).find('.addMessageGift').prop('checked', true);
      }
    }
  },

  async loadCancelData(dataObj, ajaxUrl, methodAjax, target, section) {
    const token = $('#csrfSessionToken').data('csrf');
    const ajaxObj = {
      type: methodAjax,
      url: ajaxUrl,
      contentType: 'application/json',
      data: JSON.stringify(dataObj),
      headers: {
        CSRFToken: token
      }
    };
    gfunctions.showLoader();
    try {
      const res = await gfunctions.doAjax(ajaxObj);
      switch (section) {
        case 'delivery': this.repaintDelivery(res, target);
          break;
        case 'recipient': this.repaintRecipient(res, target);
          break;
        case 'giftOptions': this.repaintGiftOptions(res, target);
          break;
        default: break;
      }
      gfunctions.hideLoader();
    } catch (err) {
      const cartAPIError = { customError: err };
      gfunctions.hideLoader();
      console.log(cartAPIError);
    }
  },

  /* Save Section Functionalities */
  saveDeliverySection() {
    $('.c-checkout-odg-sailing-nonsailing').on('click', '.btn-save-delivery', ((event) => {
      event.preventDefault();
      const deliverytype = $(event.currentTarget.closest('.delivery-details-container')).data('deliverytype');
      const dataObj = {
        selectedStateroom: $(event.currentTarget.parentElement.parentElement).find('.custom-radio .custom-control-input:checked').data('bookingid'),
        deliveryDayDetail: $(event.currentTarget.parentElement.parentElement).find('.accordion-main #sailingTime span').text(),
        deliveryType: deliverytype,
        entryNumber: $(event.currentTarget.closest('.delivery-details').previousElementSibling).find('.product').data('entrynumber'),
        sequenceNumber: $(event.currentTarget.closest('.delivery-details').previousElementSibling).find('.product').data('sequencenumber')
      };
      let ajaxUrl = '';
      let method = 'POST';
      if (window.location.hostname === 'localhost' && window.location.port === '6565') {
        ajaxUrl = '/_ui/responsive/ccl/assets/templates/checkout-onboard-delivery/checkout-onboard-delivery.json';
        method = 'GET';
      } else {
        ajaxUrl = '/shop/checkout/saveStateroomAndDay';
      }
      // AJAX call
      this.loadSaveData(dataObj, event.currentTarget, ajaxUrl, method, $(event.currentTarget).data('section'), false);
    }));
  },
  saveRecipientSection() {
    $('.c-checkout-odg-sailing-nonsailing').on('click', '.btn-save-recipient', ((event) => {
      const guestIds = [];
      const deliverytype = $(event.currentTarget.closest('.delivery-details-container')).data('deliverytype');
      $.each($(event.currentTarget.parentElement.parentElement).find('.custom-checkbox .custom-control-input:checked'), (index, elem) => {
        guestIds.push($(elem).data('guestid'));
      });

      const dataObj = {
        selectedStateroom: $(event.currentTarget).data('selectedstaterooms'), // radio button stateroom,
        deliveryDayDetail: $(event.currentTarget).data('daydetails'), // selected from accordion,
        deliveryType: deliverytype, // from the data attribute of checkbox
        entryNumber: $(event.currentTarget.closest('.recipient-details').parentElement).find('.product-wrap .product').data('entrynumber'),
        sequenceNumber: $(event.currentTarget.closest('.recipient-details').parentElement).find('.product-wrap .product').data('sequencenumber'),
        bookingIdAppendedGuestIds: guestIds

      };
      let ajaxUrl = '';
      let method = 'POST';
      if (window.location.hostname === 'localhost' && window.location.port === '6565') {
        ajaxUrl = '/_ui/responsive/ccl/assets/templates/checkout-onboard-delivery/checkout-onboard-delivery.json';
        method = 'GET';
      } else {
        ajaxUrl = '/shop/checkout/saveRecipientGuest';
      }
      this.loadSaveData(dataObj, event.currentTarget, ajaxUrl, method, $(event.currentTarget).data('section'), false);
    }));
  },

  saveGiftOptionsSection() {
    $('.c-checkout-odg-sailing-nonsailing').on('click', '.btn-save-gift', ((event) => {
      const deliverytype = $(event.currentTarget.closest('.delivery-details-container')).data('deliverytype');
      const isGiftChecked = $(event.currentTarget.parentElement.parentElement.parentElement.previousElementSibling).find('.addMessageGift').prop('checked');
      const dataObj = {
        giftMessage: $(event.currentTarget.parentNode.parentElement).find('.gift-input').val(),
        deliveryType: deliverytype, // from the data attribute of checkbox
        entryNumber: $(event.currentTarget.closest('.gift-options').parentElement).find('.product-wrap .product').data('entrynumber'),
        sequenceNumber: $(event.currentTarget.closest('.gift-options').parentElement).find('.product-wrap .product').data('sequencenumber'),
        productId: $(event.currentTarget.closest('.gift-options').parentElement).find('.product-wrap .product').data('productid'),
        selectedStateroom: $(event.currentTarget.closest('.gift-options').parentElement).find('.product-wrap .product').data('bookingid')
      };
      let ajaxUrl = '';
      let method = 'POST';
      if (window.location.hostname === 'localhost' && window.location.port === '6565') {
        ajaxUrl = '/_ui/responsive/ccl/assets/templates/checkout-onboard-delivery/checkout-onboard-delivery.json';
        method = 'GET';
      } else {
        ajaxUrl = `/shop/checkout/saveGiftAndSurprise/${deliverytype}`;
      }
      $(event.currentTarget.parentNode.parentElement).find('.saved-text').show();
      this.loadSaveData(dataObj, $(event.currentTarget.parentElement.parentElement.parentElement.previousElementSibling), ajaxUrl, method, $(event.currentTarget).data('section'), isGiftChecked);
    }));
  },

  async loadSaveData(dataObj, target, ajaxUrl, methodAjax, section, ischeckboxElem) {
    gfunctions.showLoader();
    const token = $('#csrfSessionToken').data('csrf');
    const ajaxObj = {
      type: methodAjax,
      url: ajaxUrl,
      contentType: 'application/json',
      data: JSON.stringify(dataObj),
      headers: {
        CSRFToken: token
      }
    };
    try {
      const res = await gfunctions.doAjax(ajaxObj);
      switch (section) {
        case 'delivery': this.repaintDelivery(res, target);
          // Repainting Recipient details
          $(target.parentElement.closest('.delivery-details').nextElementSibling).find('.recipient .flex-container div')[0].innerText = res.onBoardData.selectedRecipientsName;
          break;
        case 'recipient': this.repaintRecipient(res, target);
          break;
        case 'giftOptions':
          this.repaintGiftOptions(res, target[0], ischeckboxElem);
          break;
        default: break;
      }
      gfunctions.hideLoader();
    } catch (err) {
      const cartAPIError = { customError: err };
      gfunctions.hideLoader();
      console.log(cartAPIError);
    }
  },

  /* accordion functionality */
  toggleAccordion() {
    $('.c-checkout-odg-sailing-nonsailing').on('click', '#dropdownDate .accordion', ((event) => {
      event.preventDefault();
      $(event.currentTarget).toggleClass('active');
      $(event.currentTarget).attr('aria-live', 'assertive');
      const ariaExpanded = $(event.currentTarget).attr('aria-expanded');
      if (ariaExpanded === 'false') {
        $(event.currentTarget).attr('aria-expanded', 'true');
      } else {
        $(event.currentTarget).attr('aria-expanded', 'false');
      }
      const panel = $(event.currentTarget.nextElementSibling);
      if ($(event.currentTarget).hasClass('active')) {
        panel.removeClass('hide');
        // panel.addClass('show');
        $(panel).slideDown('slow');
        $(event.currentTarget).find('img').addClass('rotate-chevron');
      } else {
        // panel.removeClass('show');
        panel.addClass('hide');
        $(panel).slideUp('slow');
        $(event.currentTarget).find('img').removeClass('rotate-chevron');
      }
    }));
  },
  accordionSelect() {
    $('.c-checkout-odg-sailing-nonsailing').on('click', '.accordion-panel .selected-item', ((e) => {
      e.preventDefault();
      const parentElement = $(e.currentTarget).closest('.accordion-main');
      const elementTarget = parentElement.find('.accordion');
      const valueSelector = e.currentTarget.innerText;
      elementTarget.find('span').html(valueSelector);
      elementTarget.find('span').attr('aria-label', `${valueSelector} selected`);
      elementTarget.attr('aria-label', `${valueSelector} selected`);
      setTimeout(() => {
        elementTarget.addClass('ada-highlighted');
        elementTarget.focus();
      }, 200);
      $(e.currentTarget).closest('.accordion-panel').addClass('hide');
      elementTarget.removeClass('active').attr('aria-expanded', 'false');
      elementTarget.find('.drop-icon').removeClass('rotate-chevron');
      $('.accordion-panel button').removeClass('active');
      e.currentTarget.className += ' active';
    }));
  },
  textAreaCharacters() {
    $('.c-checkout-odg-sailing-nonsailing').on('input keyup paste', 'textarea.gift-msg-text', ((event) => {
      this.calculateTextAreaCharacter($(event.currentTarget));
    }));

    $('.c-checkout-odg-sailing-nonsailing').on('keyup paste', 'textarea.gift-msg-text', ((event) => {
      this.triggerValidationCall($(event.currentTarget));
    }));
  },

  triggerValidationCall(textareaElement) {
    clearTimeout(this.timer); // clear timer
    this.timer = setTimeout(() => {
      this.triggerValidation(textareaElement);
    }, 1000);
  },

  triggerValidation(textareaElement) {
    $(textareaElement).parents('.gift-edit-wrap').find('.gift-error-msg').remove();
    $(textareaElement).parents('.gift-edit-wrap').find('.btn-save-gift').removeAttr('disabled');
    const giftMessage = $(textareaElement).val().toString();
    if (giftMessage && giftMessage.length > 0) {
      $.ajax({
        type: 'GET',
        contentType: 'application/json',
        url: `/shop/checkout/validateGiftMessage?giftMessage=${giftMessage}`,
        dataType: 'json'
      }).done((res) => {
        if (!res) {
          $(textareaElement).parents('.gift-edit-wrap').find('.btn-wrap .btn-save-gift').before('<div class="gift-error-msg" role="alert">There’s a problem with what you entered. Please try again</div>');
          $(textareaElement).parents('.gift-edit-wrap').find('.btn-save-gift').prop('disabled', true);
        }
      }).fail(() => {
        console.log('error Occured in validation');
        $(textareaElement).parents('.gift-edit-wrap').find('.btn-wrap .btn-save-gift').before('<div class="gift-error-msg" role="alert">There’s a problem with what you entered. Please try again</div>');
        $(textareaElement).parents('.gift-edit-wrap').find('.btn-save-gift').prop('disabled', true);
      });
    }
  },

  calculateTextAreaCharacter(textareaElement) {
    const reg = /^[\w \u000-\u109F {Nd} _,.'\-: @/’()!&]*$/;
    // const reg = $('#giftMsgRegex').data('giftmsgregex');
    const regExPattern = new RegExp(reg);
    const textValue = $(textareaElement).val().toString();
    this.triggerValidationCall(textareaElement);
    if (textValue.length > 100) {
      const newtextValue = textValue.slice(0, textValue.length - 1);
      $(textareaElement).val(newtextValue);
    }
    // if (!regExPattern.test(textValue) && textValue.length) {
    //   $(textareaElement).parents('.gift-edit-wrap').find('.gift-error-msg').remove();
    //   $(textareaElement).parents('.gift-edit-wrap').find('.btn-wrap .btn-save-gift').before('<div class="gift-error-msg" role="alert">There’s a problem with what you entered. Please try again</div>');
    //   $(textareaElement).parents('.gift-edit-wrap').find('.btn-save-gift').prop('disabled', true);
    // } else {
    //   $(textareaElement).parents('.gift-edit-wrap').find('.gift-error-msg').remove();
    //   $(textareaElement).parents('.gift-edit-wrap').find('.btn-save-gift').prop('disabled', false);
    // }
    const textlimit = parseInt($(textareaElement).attr('maxlength'), 0);
    let tlength = $(textareaElement).val().length;
    $(textareaElement).val($(textareaElement).val().substring(0, textlimit));
    tlength = $(textareaElement).val().length;
    const remain = textlimit - parseInt(tlength, 0);
    const typed = textlimit - remain;
    $(textareaElement).parents('.gift-edit-wrap').find('.charac-text-remaining').attr('aria-label', `${typed} Characters typed and ${remain} Characters remaining`);
    $(textareaElement).parents('.gift-edit-wrap').find('.charac-text-remaining').text(`${remain} Characters remaining`);
  },
  shiftingPromoWaterMark() {
    $('.apply-promo .user-input-wrp').find('input').each((index, e) => {
      const $targetElement = $(`#${e.id}`).parent().find('.floating-label');
      if (!e.value.length) {
        e.nextElementSibling.classList.add('inputBlur');
        e.nextElementSibling.classList.remove('inputFocus');
        if (e.id === 'promo-id') {
          $targetElement.attr('style', 'top:28px !important');
        }
      } else {
        e.nextElementSibling.classList.add('inputFocus');
        e.nextElementSibling.classList.remove('inputBlur');
        if (e.id === 'promo-id') {
          $targetElement.attr('style', 'top:11px !important');
        }
      }
    });

    $('.apply-promo .user-input-wrp').find('input').on('focusout', (e) => {
      const $targetElement = $(`#${e.currentTarget.id}`).parent().find('.floating-label');
      if (!e.currentTarget.value.length) {
        e.currentTarget.nextElementSibling.classList.add('inputBlur');
        e.currentTarget.nextElementSibling.classList.remove('inputFocus');
        if (e.currentTarget.id === 'promo-id') {
          $targetElement.attr('style', 'top:28px !important');
        }
      }
    });

    $('.apply-promo .user-input-wrp').find('input').on('focus', (e) => {
      const $targetElement = $(`#${e.currentTarget.id}`).parent().find('.floating-label');
      e.currentTarget.nextElementSibling.classList.add('inputFocus');
      e.currentTarget.nextElementSibling.classList.remove('inputBlur');
      if (e.currentTarget.id === 'promo-id') {
        $targetElement.attr('style', 'top:11px !important');
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/components/c-checkout-odg-sailing-nonsailing/checkout-odg-sailing-nonsailing.js